import PropTypes from 'prop-types'
import React from "react"
import {connect} from "react-redux"
import {Link} from "react-router-dom"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import logo from "../../assets/images/logo.svg"
import logoLightPng from "../../assets/images/logoS.png"
import logoLightSvg from "../../assets/images/logoS.png"
import logoDark from "../../assets/images/logoS.png"
import {withTranslation} from "react-i18next"
import {changeSidebarType, showRightSidebarAction, toggleLeftmenu,} from "../../store/actions"
import NotificationDropdown from 'components/CommonForBoth/TopbarDropdown/NotificationDropdown'

const Header = props => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    props.toggleLeftmenu(!props.leftMenu)
    if (props.leftSideBarType === "default") {
      props.changeSidebarType("condensed", isMobile)
    } else if (props.leftSideBarType === "condensed") {
      props.changeSidebarType("default", isMobile)
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" className="imgLogo" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="17" />
                </span>
              </Link>

              <Link to="/" className="mt-3 logo logo-light text-start">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" className="minWidthLogo" />
                </span>
                <span className="logo-lg">
                  <img src={logoLightPng} alt="" className="imgLogo pe-3" />
                  <span className="text-light font-size-20">MERAS</span>
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item waves-effect"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars"/>
            </button>
          </div>
            {props.showProfileMenu ?
              <div className="d-flex">

                {/*<LanguageDropdown />*/}

                <div className="dropdown d-none d-lg-inline-block ms-1">
                  <button
                    type="button"
                    onClick={() => {
                      toggleFullscreen()
                    }}
                    className="btn header-item noti-icon waves-effect"
                    data-toggle="fullscreen"
                  >
                    <i className="bx bx-fullscreen"/>
                  </button>
                </div>

                {/* <NotificationDropdown /> */}
                <ProfileMenu routePrefix={props.routePrefix} />

                {/* <div
                  onClick={() => {
                    props.showRightSidebarAction(!props.showRightSidebar)
                  }}
                  className="dropdown d-inline-block"
                >
                  <button
                    type="button"
                    className="btn header-item noti-icon right-bar-toggle waves-effect"
                  >
                    <i className="bx bx-cog bx-spin"/>
                  </button>
                </div> */}
              </div> : null }
        </div>
      </header>
    </React.Fragment>
  )
}

Header.defaultProps = {
    showProfileMenu: true,
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  showProfileMenu:PropTypes.bool,
  t: PropTypes.any,
  routePrefix: PropTypes.string,
  toggleLeftmenu: PropTypes.func
}

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
  } = state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
